/*
 * The Flaire — header search trigger wiring.
 * Opens/closes the Private Concierge overlay in place. When this script runs,
 * the trigger's real href to /search is intercepted and never followed — the
 * href only fires as a no-JS fallback.
 *
 * Also neutralizes the Vitals app's "Instant Search" popover (Vitals is
 * installed as an app-embed block on this theme and renders its own search
 * UI independently of any theme markup or class name — confirmed live by
 * inspecting the actual DOM: it injects ".vitals-search-modal" and locks
 * body scroll via "vtl-g-not-scrollable" the moment it opens, regardless of
 * what was clicked or why). Rather than guess at Vitals' trigger heuristic,
 * this watches for the one reliable signal of it opening — that body class
 * — and the instant it appears, force-hides the Vitals modal, unlocks
 * scroll, and opens the real Private Concierge overlay instead. This is
 * robust regardless of how Vitals decides to fire.
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var trigger = document.getElementById('FlaireConciergeTrigger');
    var overlay = document.getElementById('FlaireConciergeOverlay');
    if (!trigger || !overlay) return;

    var closers = overlay.querySelectorAll('[data-fr-overlay-close]');

    function open() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('fr-overlay-locked');
      var input = document.getElementById('fr-cc-query');
      if (input) {
        setTimeout(function () {
          input.focus();
        }, 300);
      }
    }

    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('fr-overlay-locked');
      trigger.focus();
    }

    trigger.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        open();
      },
      true
    );

    closers.forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    // ---------- Vitals "Instant Search" suppression ----------
    var VITALS_LOCK_CLASS = 'vtl-g-not-scrollable';

    function suppressVitalsSearch() {
      var vitalsModal = document.querySelector('.vitals-search-modal');
      if (vitalsModal) {
        vitalsModal.style.setProperty('display', 'none', 'important');
      }
      document.body.classList.remove(VITALS_LOCK_CLASS);
      if (!overlay.classList.contains('is-open')) open();
    }

    if (document.body.classList.contains(VITALS_LOCK_CLASS)) {
      suppressVitalsSearch();
    }

    var vitalsObserver = new MutationObserver(function () {
      if (document.body.classList.contains(VITALS_LOCK_CLASS)) {
        suppressVitalsSearch();
      }
    });
    vitalsObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  });
})();
